import { BlankLayoutProps } from "../../types/layouts/BlankLayout/BlankLayout";

export default function BlankLayout({ children }: BlankLayoutProps) {
  return <div>{children}</div>;
}
